<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-row>
        <v-col>
          <span>
            {{ $t('availabilityPeriod') }}
          </span>
        </v-col>

        <v-col cols="auto">
          <BaseDialogActions hideFullscreen hideRefresh></BaseDialogActions>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pt-4">
      <v-row v-if="initialized">
        <v-col cols="12">
          <DatePicker
          @date-picked="startDatePicked"
          clearable
          elementId="tract-availability-start-date"
          :startDate="availabilityStart"
          @valid-date="(val) => {
            isValidStartDate = val
          }"
          :hint="startHint"
          :dateLabel="$t('availabilityStart')"/>
        </v-col>
        <v-col cols="12">
          <DatePicker
          @date-picked="endDatePicked"
          clearable
          elementId="tract-availability-end-date"
          :startDate="availabilityEnd"
          :min="availabilityStart"
          @valid-date="(val) => {
            isValidEndDate = val
          }"
          :hint="endHint"
          :dateLabel="$t('availabilityEnd')"/>
        </v-col>
        <v-col cols="12" v-if="isEndBeforeStart">
          <span class="error--text">{{ $t('startDateAfterEndDate') }}</span>
        </v-col>
        <v-col cols="12" v-if="isHarvestOutside">
          <span class="error--text">{{ $t('harvestWithinAvailability') }}</span>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="pb-4 px-0">
      <v-row justify="end" align="center">
        <v-col cols="auto">
          <v-btn @click="onConfirm" color="primary" :disabled="isEndBeforeStart || isHarvestOutside">{{$t('confirm')}}</v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AvailabilityPeriodForm',

  components: {
    DatePicker: () => import('@/components/helper/DatePicker.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    tract: {
      type: Object,
      required: true
    },

    startHint: {
      type: String,
      default: ''
    },

    endHint: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    availabilityStart: null,
    availabilityEnd: null,
    isValidStartDate: true,
    isValidEndDate: true,
    initialized: false
  }),

  mounted () {
    this.availabilityStart = this.tract.availabilityStartDate
    this.availabilityEnd = this.tract.availabilityEndDate
    this.initialized = true
  },

  computed: {
    isEndBeforeStart () {
      if (!this.availabilityStart || !this.availabilityEnd) return false
      return moment(this.availabilityEnd).isBefore(moment(this.availabilityStart), 'day')
    },

    isHarvestOutside () {
      const { harvestStartDate, harvestEndDate } = this.tract
      return (!!this.availabilityStart && !!harvestStartDate && moment(harvestStartDate).isBefore(moment(this.availabilityStart), 'day')) ||
        (!!this.availabilityEnd && !!harvestEndDate && moment(harvestEndDate).isAfter(moment(this.availabilityEnd), 'day'))
    }
  },

  methods: {
    startDatePicked (date) {
      this.availabilityStart = date
    },

    endDatePicked (date) {
      this.availabilityEnd = date
    },

    onConfirm () {
      this.$emit('confirm', {
        availabilityStart: this.availabilityStart,
        availabilityEnd: this.availabilityEnd
      })
    }
  }
}
</script>
